import { Paper } from "@mui/material";
import React from "react";
import CardTooltip from "../card-tooltip";
import { IoInformationCircleOutline } from "react-icons/io5";

function BacklinkGapTooltip({ ref_domain, backlinks }) {
  return (
    <CardTooltip
      element={
        <>
          <IoInformationCircleOutline
            style={{
              width: "1.3em",
              height: "1.3em",
              color: "black",
            }}
          />
        </>
      }
    >
      <Paper className="domain_gap_paper">
        <div className="">
          <span>
            Referring Domains <b>{ref_domain}</b>
          </span>
          <span className="mb-0">
            Backlinks <b>{backlinks}</b>
          </span>
        </div>
      </Paper>
    </CardTooltip>
  );
}

export default BacklinkGapTooltip;
